/** 客服系统 **/
import Layout from "@/views/layout/Layout";
const customerCenterRouter = {
  path: "/customerCenter",
  component: Layout,
  name: "customerCenter",
  meta: {
    title: "客服中心",
    icon: "customerServiceCenter",
    roles: ["kefuzhongxin"]
  },
  alwaysShow: true,
  children: [
    {
      path: "callSetup",
      component: () => import("@/views/customerCenter/callSetup/index"),
      meta: {
        title: "话务设置",
        roles: ["huawushezhi"]
      },
      alwaysShow: true,
      children: [
        {
          path: "ruleSetup",
          component: () => import("@/views/customerCenter/callSetup/ruleSetup"),
          name: "呼入规则设置",
          meta: {
            title: "呼入规则设置",
            roles: ["huruguizeshezhi"]
          },
          children: []
        },
        {
          path: "ruleWhiteList",
          component: () =>
            import("@/views/customerCenter/callSetup/ruleWhiteList"),
          name: "呼入规则白名单",
          meta: {
            title: "呼入规则白名单",
            // roles: ["baimingdan"]
          },
          hidden: true,
          children: []
        },
        {
          path: "seatSetup",
          component: () => import("@/views/customerCenter/callSetup/seatSetup"),
          name: "坐席设置",
          meta: {
            title: "坐席设置",
            roles: ["zuoxishezhi"]
          },
          children: []
        },
        {
          path: "blackList",
          component: () => import("@/views/customerCenter/callSetup/blackList"),
          name: "黑名单",
          meta: {
            title: "黑名单",
            roles: ["heimingdan_zx"]
          },
          children: []
        }
      ]
    },
    {
      path: "callPerform",
      component: () => import("@/views/customerCenter/callPerform/index"),
      meta: {
        title: "话务执行",
        roles: ["huawuzhixing"]
      },
      alwaysShow: true,
      children: [
        {
          path: "mySeat",
          component: () => import("@/views/customerCenter/callPerform/mySeat"),
          name: "我的坐席",
          meta: {
            title: "我的坐席",
            roles: ["wodezuoxi"],
            keepAlive: true
          },
          children: []
        },
        {
          path: "guestOrg",
          component: () =>
            import("@/views/customerCenter/callPerform/guestOrg"),
          name: "客商组织",
          meta: {
            title: "客商组织",
            roles: ["keshangzuzhi"]
          },
          children: []
        },
        {
          path: "guestArchives",
          component: () =>
            import("@/views/customerCenter/callPerform/guestArchives"),
          name: "客商档案",
          meta: {
            title: "客商档案",
            roles: ["keshangdangan"]
          },
          children: []
        }
      ]
    },
    {
      path: "callMan",
      component: () => import("@/views/customerCenter/callMan/index"),
      meta: {
        title: "话务管理",
        roles: ["huawuguanli"]
      },
      alwaysShow: true,
      children: [
        {
          path: "callRecord",
          component: () => import("@/views/customerCenter/callMan/callRecord"),
          name: "实时通话记录",
          meta: {
            title: "实时通话记录",
            roles: ["tonghuajilu"]
          },
          children: []
        },
        {
          path: "customerCenterReport",
          component: () =>
            import("@/views/customerCenter/callMan/customerCenterReport"),
          name: "客服报表",
          meta: {
            title: "客服报表",
            roles: ["kefubaobiao"]
          },
          children: []
        },
        {
          path: "callRecordHistory",
          component: () =>
            import("@/views/customerCenter/callMan/callRecordHistory"),
          name: "历史通话记录",
          meta: {
            title: "历史通话记录",
            roles: ["tonghuajilulishi"]
          },
          children: []
        },
        {
          path: "customerCenterReportHistory",
          component: () =>
            import(
              "@/views/customerCenter/callMan/customerCenterReportHistory"
            ),
          name: "客服报表历史",
          meta: {
            title: "客服报表历史",
            roles: ["kefubaobiaolishi"]
          },
          children: []
        }
      ]
    }
  ]
};

export default customerCenterRouter;
